import { browser } from '$app/environment';
import { page } from '$app/state';
import { COOKIE_NAMES } from '$lib/services/cookies/constants';
import { Cookies, fromDocument } from '$lib/services/helpers/cookies';
import { URLPrefixToAPIMarket } from '../market/constants';

export const pushEvent = (event: string, payload: Record<string, unknown> = {}) => {
    const isLoggedIn = page.data.isLoggedIn;
    const market = page.data.market;
    if (window.dataLayer === undefined || !Array.isArray(window.dataLayer)) {
        console.warn('window.dataLayer is not initialized');
        return;
    }

    const requestCookies = new Cookies(fromDocument(document));
    const kazumoMediumCookieValue = requestCookies.get(COOKIE_NAMES.KAZUMO_MEDIUM) || '';
    const kazumoTrackingIdCookieValue = requestCookies.get(COOKIE_NAMES.TRACKING_ID) || '';

    let affIdValue = '';
    let btagValue = '';

    try {
        if (kazumoMediumCookieValue) {
            const decodedCookie = atob(kazumoMediumCookieValue);
            const {
                referrerInfo: {
                    metadata: { affId: affTrackId = '', bannerId: btag = '' } = {}
                } = {}
            } = JSON.parse(decodedCookie);

            affIdValue = affTrackId;
            btagValue = btag;
        }
    } catch (e) {
        console.error('Error parsing kazumoMedium cookie');
    }

    const defaultPayload = {
        lang: market?.slug,
        market: URLPrefixToAPIMarket[market?.slug] ?? '',
        userStatus: isLoggedIn ? 'Logged-In' : 'Logged-Out',
        kazumoTrackingId: kazumoTrackingIdCookieValue,
        affTrackId: affIdValue,
        btag: btagValue,
        ...(isLoggedIn && { userId: page.data.player?.playerId })
    };

    window?.dataLayer?.push({
        event,
        ...defaultPayload,
        ...payload
    });
};

export type TPageViewPayload = {
    page?: string;
    pagePath?: string;
    pageReferrer?: string;
    pageTitle?: string;
    pagePreviousUrl?: string;
} & Record<string, string>;
export const pageview = (payload: TPageViewPayload = {}) => {
    if (!browser) return;
    const {
        url: { pathname, search, hash }
    } = page;
    return pushEvent('pageView', {
        page: '',
        pagePath: `${pathname}${search}${hash}`,
        pageReferrer: document?.referrer,
        pageTitle: document?.title,
        ...payload
    });
};
